angular.module("tableRequestCustomer.components", []).component("tableRequestCustomer", {
  templateUrl: "ng/components/cruscottoRichiestaClienti/tableRequestCustomer/tableRequestCustomer.view.html",
  bindings: {
    filter: '<',
    listPractice: "=",
    getPracticeList: "&",
    isPending: "="
  },
  controllerAs: "tableRequestCustomerCtrl",
  controller: function TableRequestCustomer(
    $financialApiService,
    $location,
    $transactionFactory,
    RichiestePostVendita,
    $modalService,
    $RichiestePostVenditaService,
    $timeout
  ) {
    var self = this;

    self.$onInit = function () {
      self.tempId = "";
      self.tempIndex = "";
      self.buttonDisabled = false;
      self.isPostVendita = false;
      self.loaderConfirm = false;
      self.supportModel = {
        loaderRiprendi: [],
        loaderDettaglio: [],
        loaderRiapri: [],
        loaderEliminaPv: []
      }
    };

    self.$onChanges = function (changes) {
      if (changes && changes.filter.currentValue) {
        //self.getPracticeList();
      }
    }

    function updateOffsetAndSearch() {
      self.filter.offset = (self.filter.pageIndex - 1) * self.filter.limit;
      self.getPracticeList();
    }

    self.pageSIndexIndietro = function (value) {
      if (value == "init") {
        self.filter.pageIndex = 1;
      } else {
        if (self.filter.pageIndex > 1) {
          self.filter.pageIndex--;
        }
      }
      updateOffsetAndSearch();
    };

    self.pageSIndexAvanti = function (value) {
      if (value == "end") {
        //subito pagina finale
        self.filter.pageIndex = self.filter.totalPages;
      } else {
        //avanzo +1
        if (self.filter.pageIndex < self.filter.totalPages) {
          self.filter.pageIndex++;
        }
      }
      updateOffsetAndSearch();
    };

    self.riprendi = function (id, index, confirm) {
      self.supportModel.loaderRiprendi[index] = true;
      $financialApiService.lavoraRichiestaPv(id, confirm)
      .then(function(response){
        self.supportModel.loaderRiprendi[index] = false;
        if(response.showPopup && !confirm){
          self.openTakeOverModal(id, index);
        }
        else{
          var richiestePostVenditaModel = RichiestePostVendita.build(response);
          $transactionFactory.set(richiestePostVenditaModel);
          $location.path('/dettaglioCruscottoRichiestaClienti')
        }
      })
      .catch(function (){
        self.supportModel.loaderRiprendi[index] = false;
      })
    }

    self.dettaglio = function (id, index) {
      self.supportModel.loaderDettaglio[index] = true;

      $financialApiService.dettaglioRichiestaPv(id)
        .then(function (response) {
          self.supportModel.loaderDettaglio[index] = false;
          var richiestePostVenditaModel = RichiestePostVendita.build(response);
          $transactionFactory.set(richiestePostVenditaModel);
          $location.path('/dettaglioCruscottoRichiestaClienti')
        })
        .catch(function () {
          self.supportModel.loaderDettaglio[index] = false;
        })
    }

    self.openModal = function (id, index) {
      self.tempId = id;
      self.tempIndex = index;
      $modalService.openModal('reopenRequest');
    }

    self.closeModal = function () {
      $modalService.closeModal("reopenRequest");
    };

    self.openTakeOverModal = function (id, index) {
      self.tempId = id;
      self.tempIndex = index;
      $timeout(function () {
          $modalService.openModal("takeOverPracticeModal");
        }, 500);
    }
    self.closeTakeOverModal = function () {
      $modalService.closeModal("takeOverPracticeModal");
    };

    self.riapri = function () {
      self.supportModel.loaderRiapri[self.tempIndex] = true;

      $financialApiService.reopenRequestPv(self.tempId)
        .then(function (response) {
          self.supportModel.loaderRiapri[self.tempIndex] = false;
          var richiestePostVenditaModel = RichiestePostVendita.build(response);
          $transactionFactory.set(richiestePostVenditaModel);
          $location.path('/cruscottoRichiestaClienti');
          $modalService.closeModal("reopenRequest");
          self.getPracticeList();
        })
        .catch(function () {
          self.supportModel.loaderRiapri[self.tempIndex] = false;
          $modalService.closeModal("reopenRequest");
        })
    }

      self.deletePracticePv = function (pratica, index) {
        self.showModalDelete = true;
        self.isPostVendita = true;
        self.supportModel.loaderEliminaPv[index] = true;
        self.pratica = pratica;
        $timeout(function () {
          $modalService.openModal("modal-confirm");
          self.supportModel.loaderEliminaPv[index] = false;
        }, 500)

      };

      self.closeModalPv = function (value) {
        $modalService.closeModal(value);
        self.showModalDelete = false;
        self.showMoldaDuplicaAutorizza = false;
      };      
      
      self.confirmSigners = function (fromCloseDuplicate) {
        self.buttonDisabled = true;
        self.loaderConfirm = true;

        if (self.isPostVendita) {
          $RichiestePostVenditaService
            .annullaPracticePv(self.pratica.id)
            .then(function () {
              self.getPracticeList();
              self.loaderConfirm = false;
              $modalService.closeModal("modal-confirm");

              self.buttonDisabled = false;
              self.showModalDelete = false;
            })
            .catch(function () {
              self.loaderConfirm = false;
              self.buttonDisabled = false;
            });
        } 
      };
  }
})